/**
 * Página de Análisis de Ventas
 * Dashboard de ventas con métricas y tendencias
 */

import React from "react";
import {
  Box,
  Stack,
  CircularProgress,
  Alert,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useDashboardOverview } from "../hooks/useAnalytics";
import DashboardVentas from "../components/DashboardVentas";

const VentasPage: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const dashboardQuery = useDashboardOverview();

  if (dashboardQuery.isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <Stack spacing={2} alignItems="center">
          <CircularProgress size={60} />
          <Typography variant="h6" color="text.secondary">
            Cargando datos de ventas...
          </Typography>
        </Stack>
      </Box>
    );
  }

  if (dashboardQuery.isError) {
    return (
      <Alert severity="error" sx={{ mb: 2 }}>
        Error al cargar los datos de ventas. Verifique que la API esté
        disponible en /api y que la variable VITE_API_URL esté configurada si
        aplica.
      </Alert>
    );
  }

  return (
    <Box sx={{ p: isMobile ? 2 : 3 }}>
      <Stack spacing={3}>
        <DashboardVentas />
      </Stack>
    </Box>
  );
};

export default VentasPage;
